import 'scss/form/component/form_multi_radio';

import React, {Component} from 'react';
import * as R from 'ramda';
import t from 'tcomb-form';
import classNames from 'classnames';

export default class FormMultiRadio extends Component {
    static displayName = 'FormMultiRadio';
    static defaultProps = {
        maxSelectable: 4
    };

    constructor(props) {
        super(props);
        this.state = {value: props.value};
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.props.value) {
            this.setState({
                value: nextProps.value
            });
        }
    }

    handleClick = value => {
        let nextState = null;
        if (R.indexOf(value, this.state.value) !== -1) {
            nextState = R.remove(R.indexOf(value, this.state.value), 1, this.state.value);
            if (!!this.props.options.disableDeselectAll && nextState.length === 0) {
                nextState = [value];
            }
            this.setState({
                value: nextState
            });
        } else {
            if (this.props.options.deselectPropValue) {
                if (
                    value === this.props.options.deselectPropValue &&
                    R.indexOf(this.props.options.deselectPropValue, this.state.value) === -1
                ) {
                    nextState = [value];
                } else if (
                    R.indexOf(this.props.options.deselectPropValue, this.state.value) !== -1 &&
                    value !== this.props.options.deselectPropValue
                ) {
                    nextState = R.append(value, this.state.value);
                    nextState = R.remove(
                        R.indexOf(this.props.options.deselectPropValue, nextState),
                        1,
                        nextState
                    );
                } else {
                    nextState = R.append(value, this.state.value);
                    if (
                        !R.prop('noMaxSelectable', this.props.options) &&
                        R.length(this.state.value) >=
                            (this.props.options.maxSelectable || this.props.maxSelectable)
                    ) {
                        nextState = R.remove(0, 1, nextState);
                    }
                }
            } else {
                nextState = R.append(value, this.state.value);
                if (
                    !R.prop('noMaxSelectable', this.props.options) &&
                    R.length(this.state.value) >=
                        (this.props.options.maxSelectable || this.props.maxSelectable)
                ) {
                    nextState = R.remove(0, 1, nextState);
                }
            }
            this.setState({
                value: nextState
            });
        }
        this.props.onChange(nextState, this.props.ctx.path);
    };

    getValidationOptions() {
        return {
            path: this.props.ctx.path,
            context: t.mixin(t.mixin({}, this.props.context || this.props.ctx.context), {
                options: this.props.options
            })
        };
    }

    validate() {
        const value = this.state.value;
        const result = t.validate(value, this.props.type, this.getValidationOptions());
        this.setState({hasError: !result.isValid()});
        return result;
    }

    render() {
        const {value, hasError} = this.state;
        const {ctx, options} = this.props;

        const labelText = options.label || ctx.label;
        const label = labelText ? <label className="control-label">{labelText}</label> : null;
        const iconMap = options.iconMap;
        const noSort = options.noSort;
        const {name} = ctx;
        const {optionsMap} = options;
        let enumPairs = optionsMap ? R.toPairs(optionsMap) : R.toPairs(this.props.type.meta.map);
        if (!noSort) enumPairs = R.sortBy(R.nth(1), enumPairs);

        const radioButtons = enumPairs.map(([v, label]) => {
            const isSelected = R.indexOf(v, value) !== -1;
            let iconStyle = null;

            if (iconMap) {
                let icon = iconMap[v];

                if (R.is(Array, icon)) {
                    icon = isSelected ? icon[1] : icon[0];
                    iconStyle = {
                        backgroundImage: `url(${icon})`
                    };
                }
            }
            return (
                <div
                    key={v}
                    className={classNames(
                        'radio-multi-btn',
                        isSelected && 'active',
                        v,
                        label,
                        options.customBtnClass
                    )}
                    onClick={this.handleClick.bind(this, v)}
                >
                    {iconStyle && <div className="radio-multi-btn-icon" style={iconStyle} />}
                    <div className="radio-multi-btn-label">{label}</div>
                </div>
            );
        });

        return (
            <div
                id={name}
                name={name}
                className={classNames(
                    'radio-multi-group-horizontal',
                    'form-group',
                    hasError && 'has-error'
                )}
            >
                {label}
                <div className="radio-multi-btns">{radioButtons}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./form_components/form_multi_radio.js